import React from 'react';

/** Spreadsheet illustration — 4-col × 4-row cell grid with tinted header row. */
const CellGrid = () => (
  <div className="ill-grid" aria-hidden="true">
    <div className="ill-grid-row ill-grid-row-head">
      <span /><span /><span /><span />
    </div>
    <div className="ill-grid-row"><span /><span /><span /><span /></div>
    <div className="ill-grid-row"><span /><span /><span /><span /></div>
    <div className="ill-grid-row"><span /><span /><span /><span /></div>
  </div>
);

export default CellGrid;
